module.exports = __webpack_public_path__ + "media/images/user/lp/step/step2-b9cff67ed1d071772e82d38dfdd002d9.png";